import { useTranslation, UseTranslationOptions } from 'react-i18next';

/**
 * Wrapper applicatif autour de useTranslation.
 * Namespace par défaut : `common`.
 */
export function useAppTranslation(
  ns: string | string[] = 'common',
  options?: UseTranslationOptions<string>
) {
  return useTranslation(ns, options);
}
